import Plyr from 'plyr';
import {v4 as uuidv4} from 'uuid';

const $ = window.jQuery;


const formPopup = {
    init: () => {
        domCache();
        handleLinks();
        handleClose();
        $(document).on("gform_confirmation_loaded", function (e, form_id) {
            $('#popup-form-'+form_id).find('.download-brochure')[0].click()
            formSubmit = true;
        });
    }
};

const $DOM = {};
const layerVisibleClass = "is-open";
const lockBody = "lock-scroll";
var formSubmit = false;

const domCache = () => {
    $DOM.body = $("body");
    $DOM.links = $("div[data-popup]");
    $DOM.closeBtns = $(".form-layer-close");
}

const handleLinks = () => {
    $DOM.links.on("click", function() {
        let $popupId = $(this).data("popup");
        let $popupSubject = $(this).data("subject");
        let $popupLink = $(this).data("file");
        openPopup($popupId,$popupSubject,$popupLink);
    });
}

const openPopup = ($popupId,$popupSubject,$popupLink) => {
    let $popupForm = $("#"+$popupId+"");

    if ($popupForm.find('.request_subject-field input').length){
        $popupForm.find('.request_subject-field input').prop('value',$popupSubject);
    }

    if ($popupForm.find('.download-brochure').length){
        $popupForm.find('.download-brochure').attr('href', $popupLink);
    }

    $popupForm.addClass(layerVisibleClass);
    $DOM.body.addClass(lockBody);
}

const handleClose = () => {
    $DOM.closeBtns.on("click", function() {
        let formPopup = $(this).parents('.popup-layer');
        closePopup(formPopup);
    });

    // Escape Listener
    $(document).keyup(function(e){
        let formPopup = $('.popup-layer.'+layerVisibleClass);
        if (e.keyCode != 27 || !formPopup.length) return;
        closePopup(formPopup);
    });
}

const closePopup = ($popupForm) => {
    $DOM.body.removeClass(lockBody);
    $popupForm.removeClass(layerVisibleClass);
    $popupForm.find('.request_subject-field input').prop('value','')
    $popupForm.find('.download-brochure').prop('href','');
    if (formSubmit) location.reload();
}

export default formPopup;
